export const languageCountryMap: Record<string, string> = {
    en: 'gb',
    pt: 'br',
    zh: 'cn',
    he: 'il',
    iw: 'il',
    fa: 'ir',
    ji: 'ye',
    ja: 'jp',
    ak: 'gh',
    sq: 'al',
    hy: 'am',
    asa: 'tz',
    bem: 'zm',
    bez: 'tz',
    tzm: 'ma',
    chr: 'us',
    cgg: 'ug',
    cs: 'cz',
    da: 'dk',
    ebu: 'ke',
    fil: 'ph',
    ff: 'sn',
    lg: 'ug',
    ka: 'ge',
    el: 'gr',
    guz: 'ke',
    ha: 'ng',
    haw: 'us',
    hi: 'in',
    ig: 'ng',
    kea: 'cv',
    kab: 'dz',
    kl: 'gl',
    kln: 'ke',
    kam: 'ke',
    kk: 'kz',
    kok: 'in',
    ko: 'kr',
    khq: 'ml',
    ses: 'ml',
    lag: 'tz',
    luo: 'ke',
    luy: 'ke',
    jmc: 'tz',
    kde: 'tz',
    gv: 'im',
    mas: 'ke',
    mer: 'ke',
    mfe: 'mu',
    naq: 'na',
    nd: 'zw',
    nb: 'no',
    nn: 'no',
    nyn: 'ug',
    or: 'in',
    rm: 'ch',
    rof: 'tz',
    rwk: 'tz',
    saq: 'ke',
    seh: 'mz',
    ii: 'cn',
    xog: 'ug',
    sw: 'tz',
    gsw: 'ch',
    shi: 'ma',
    dav: 'ke',
    te: 'in',
    teo: 'ug',
    ti: 'et',
    ur: 'pk',
    vun: 'tz',
    yo: 'ng',
    zu: 'za',
    aa: 'dj',
    xh: 'za',
    ts: 'za',
    tig: 'er',
    ssy: 'er',
    rtm: 'er',
    rn: 'bi',
    qu: 'pe',
    rar: 'ck',
    nrb: 'ke',
    ny: 'mw',
    mi: 'nz',
    ln: 'cd',
    kun: 'cd',
    ku: 'tr',
    lo: 'la',
    hif: 'fj',
    fan: 'ga',
};
